//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { IInstagramEngager } from '@apis/instagram-user/instagramUserApiModel';

export enum INSTAGRAM_AUDIENCE_ACTIONS {
  REQUEST_SUMMARY_TOP_RECENT_ENGAGERS = 'INSTAGRAM_AUDIENCE/REQUEST_SUMMARY_TOP_RECENT_ENGAGERS',
  RECEIVE_SUMMARY_TOP_RECENT_ENGAGERS = 'INSTAGRAM_AUDIENCE/RECEIVE_SUMMARY_TOP_RECENT_ENGAGERS',
  RECEIVE_SUMMARY_TOP_RECENT_ENGAGERS_FAILURE = 'INSTAGRAM_AUDIENCE/RECEIVE_SUMMARY_TOP_RECENT_ENGAGERS_FAILURE',
}

export interface IInstagramAudienceState {
  isFetchingSummaryTopRecentEngagers: boolean;
  summaryTopRecentEngagers: IInstagramEngager[];
  fetchingSummaryTopRecentEngagersError: string | undefined;
}
